export type DataSource = string

// Keep existing value-style call sites while allowing opaque source keys from query.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataSource = Object.freeze({
	CURRENT_PATIENT: "current_patient" as DataSource,
	CPPOPT_ANALYSIS: "cppopt_analysis" as DataSource,
	ASSOCIATED_OFFLINE_DSA: "associated:offline_dsa" as DataSource,
	REVIEW_TIMESERIES: "review:timeseries" as DataSource,
})
